import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

// SERVICES/SERVICIOS  ----------------------------------------------------
import { ValidatorService } from '../../services/validators/validator.service';
import { RegistrationService, DistrictDataResponse } from '../../services/registration/registration.service';
import { LoadService } from '../../components/loader/loader.service';

// INTERFACES/INTERFACES  -------------------------------------------------
import { District } from '../../models/district.model';
import { Sectional } from '../../models/sectional.model';
import { Church } from '../../models/church.model';

// COMPONENTS/COMPONENTES  ------------------------------------------------
import { AlertComponent } from '../../components/alert/alert.component';
import { RequireChurchComponent } from '../../components/modals/require-church/require-church.component';

@Component({
    selector: 'app-register-1',
    templateUrl: './register-1.component.html',
    styleUrls: ['./register-1.component.scss']
})
export class Register1Component implements OnInit {

    // -----------------------------------------------------------------
    // ATTRIBUTES/ATRIBUTOS
    // -----------------------------------------------------------------
    firstFormGroup: FormGroup;
    @Output() FormEvent1 = new EventEmitter<any>();
    loader: any

    districts: District[] = [];
    districtData: DistrictDataResponse;
    //sectionals: Sectional[] = [];
    sectionals: any[] = [];
    churches: Church[] = [];

    filteredSectionals: Observable<Sectional[]>;
    filteredChurches: Observable<Church[]>;

    @Output() needChurch: EventEmitter<any> = new EventEmitter();
    canNext: boolean = false;

    // -----------------------------------------------------------------
    // CONSTRUCTOR
    // -----------------------------------------------------------------
    constructor(
        private dialog: MatDialog,
        private registrationService: RegistrationService,
        private loadService: LoadService,
        private _router: Router,
        private customValidators: ValidatorService
    ) {
        this.firstFormGroup = new FormGroup({
            ctrlDistrict: new FormControl({ value: '', disabled: false }, Validators.required),
            ctrlSectional: new FormControl({ value: '', disabled: true }, [Validators.required, customValidators.validAutocomplete]),
            ctrlChurch: new FormControl({ value: '', disabled: true }, [Validators.required, customValidators.validAutocomplete])
        });
    }

    ngOnInit() {
        this.loader = this.loadService.createLoad('');
        this.loader.open()
        this.registrationService.getDistricts().subscribe((districts: District[]) => {
            this.districts = districts;
            this.loader.close()
        });
    }

    loadDistrictData(districtId) {
        this.registrationService.getDistrictDataById(districtId).subscribe((districtData: DistrictDataResponse) => {
            this.districtData = districtData;
            this.sectionals = this.districtData.sectionals
            this.setSectionalsFilterOptions()
        });
    }

    setSectionalsFilterOptions() {
        this.filteredSectionals = this.firstFormGroup.get('ctrlSectional').valueChanges.pipe(
            startWith(''),
            map(val => this.filterSectional(val))
        );
    }

    displayFnSectional(sectional?: Sectional): string | undefined {
        return sectional ? sectional.name : undefined;
    }

    filterSectional(opt: any): Sectional[] {
        if (typeof (opt) == "string") {
            return this.sectionals.filter(option => option.name.toLowerCase().indexOf(opt.toLowerCase()) !== -1);
        } else if (typeof (opt) == "object") {
            return this.sectionals.filter(option => option.name.toLowerCase().indexOf(opt.name.toLowerCase()) !== -1);
        } else {
            return this.sectionals;
        }
    }

    setChurchFilterOptions() {
        this.filteredChurches = this.firstFormGroup.get('ctrlChurch').valueChanges.pipe(
            startWith(''),
            map(val => this.filterChurch(val))
        );
    }

    displayFnChurch(church?: Church): string | undefined {
        return church ? church.name : undefined;
    }

    filterChurch(opt: any): Church[] {
        if (typeof (opt) == "string") {
            return this.churches.filter(option => option.name.toLowerCase().indexOf(opt.toLowerCase()) !== -1);
        } else if (typeof (opt) == "object") {
            return this.churches.filter(option => option.name.toLowerCase().indexOf(opt.name.toLowerCase()) !== -1);
        } else {
            return this.churches;
        }
    }

    changeDistrict(districtValue) {
        const sectionalControl = this.firstFormGroup.get('ctrlSectional')
        const churchControl = this.firstFormGroup.get('ctrlChurch')

        if (districtValue !== undefined && districtValue !== null) {
            if (districtValue > 0) {
                sectionalControl.setValue("")
                sectionalControl.enable()
                churchControl.setValue("")
                churchControl.disable()
            }
        }
    }

    changeSectional(sectional) {
        const churchControl = this.firstFormGroup.get('ctrlChurch')
        if (sectional !== undefined && sectional !== null) {
            if (sectional.id > 0) {
                this.loadChurchData(sectional)
                churchControl.enable()
            }
        }
    }

    loadChurchData(sectional) {
        if (sectional.id > 0) {
            this.churches = []
            const cities = sectional.cities
            cities.forEach(city => {
                const churches = city.churches
                churches.forEach(ch => {
                    let church = new Church
                    church.id = ch.id
                    church.name = ch.name
                    this.churches.push(church)
                });
            });
            this.setChurchFilterOptions()
        }
    }

    onSave() {
        if (this.firstFormGroup.valid || this.canNext) {
            this.FormEvent1.emit(this.firstFormGroup.value)
        } else {
            this.dialog.open(AlertComponent, {
                width: '35vw',
                disableClose: true,
                data: {
                    title: 'Atención',
                    content: "Formulario inválido, verifique los datos ingresados."
                }
            })
        }
    }

    requestChurch() {
        const ref = this.dialog.open(RequireChurchComponent, {
            minWidth: '33vw'
        });

        ref.afterClosed()
            .subscribe((data) => {
                if(data)
                {
                    this.canNext = true;
                    this.needChurch.emit(data);
                }
            })
    }

back() {
        this._router.navigate(['/'])
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/register-1/register-1.component.ts